import Vue                  from 'vue'
import VueRouter            from 'vue-router'
import Auth                 from './filters/auth'
import {Groups}             from '../config/enum/Groups'
import {ProductTypes}       from '../config/enum/ProductTypes'
import {ProjectStatuses}    from '../config/enum/ProjectStatuses'
import {SuperFamilies}      from '../config/enum/SuperFamilies'
import {store}              from '../store'
Vue.use(VueRouter)

export const router = new VueRouter({
    mode: 'history',
    scrollBehavior (to, from, savedPosition) {
        if (to.hash) {
          return {selector: to.hash}
        } else {
          return {x: 0, y: 0}
        }
    },
    routes: [
        {
            path: '/',
            name: 'app',
            redirect: { name: 'projects' },

            component: require('../layouts/app/Layout.vue').default,

            children: [
                //#region - Projects
                {
                    path: 'projets',
                    name: 'projects',
                    components: {
                        app_content: require('../views/projects/list/List.vue').default
                    },
                    props: {
                        app_content: { filter : 'status|<>|' + ProjectStatuses[3].value + ',status|<>|' + ProjectStatuses[4].value }
                    }
                },
                {
                    path: 'projets/tous',
                    name: 'all-projects',
                    components: {
                        app_content: require('../views/projects/list/List.vue').default
                    },
                },
                {
                    path: 'projets/mes-projets',
                    name: 'my-projects',
                    components: {
                        app_content: require('../views/projects/list/List.vue').default
                    },
                    props: {
                        //app_content: { filter: 'user_id|=|' + store.auth.state.user.id }
                        app_content: { filter:`user_id|=|${localStorage.userId}` }
                        //app_content:{ filter: `${console.log(store)}`}
                    }
                },
                {
                    path: 'projets/archives',
                    name: 'archived-projects',
                    components: {
                        app_content: require('../views/projects/list/List.vue').default
                    },
                    props: {
                        app_content: { filter: 'status|=|' + ProjectStatuses[4].value }
                    }
                },
                {
                    path: 'projets/:id',
                    name: 'single-project',
                    redirect: { name: 'project-products-suppliers' },
                    components: {
                        app_content: require('../views/projects/single/Single.vue').default
                    },

                    children: [
                        {
                            path: 'produits-concurrents',
                            name: 'project-products-competitors',
                            components: {
                                default: require('../views/projects/single/Competitors.vue').default
                            }
                        },
                        {
                            path: 'produits-fournisseurs',
                            name: 'project-products-suppliers',
                            components: {
                                default: require('../views/projects/single/Suppliers.vue').default
                            }
                        },
                        {
                            path: 'produits-sidamos',
                            name: 'project-products-sidamos',
                            components: {
                                default: require('../views/projects/single/Sidamos.vue').default
                            }
                        },
                        {
                            path: 'fichiers',
                            name: 'project-files',
                            components: {
                                default: require('../views/projects/single/Files.vue').default
                            }
                        }

                    ]
                },
                //#endregion


                //#region - Products
                // {
                //     path: 'produits',
                //     name: 'products_wf',
                //     redirect: { path: 'produits/' + SuperFamilies[0].label}
                // },
                //{
                //    path: 'produits/:super_family',
                //    name: 'products',
                //    components: {
                //        app_content: require('../views/products/list/List.vue').default
                //    },
                //    props: {
                //        app_content: {
                //            filter: 'type|=|' + ProductTypes[0].value ,
                //        }
                //    }
                //},
                {
                  path: 'produits/groupe/:group',
                  name: 'products-group',
                  components: {
                      app_content: require('../views/products/list/List.vue').default
                  },
                  props: {
                      app_content: {
                          filter: 'type|=|' + ProductTypes[0].value ,
                      }
                  }
              },
                {
                    path: 'produits/:group/fournisseurs',
                    name: 'products-suppliers',
                    components: {
                        app_content: require('../views/products/list/List.vue').default
                    },
                    props: {
                        app_content: { filter: 'type|=|' + ProductTypes[1].value }
                    }
                },
                {
                    path: 'produits/:group/concurrents',
                    name: 'products-competitors',
                    components: {
                        app_content: require('../views/products/list/List.vue').default
                    },
                    props: {
                        app_content: { filter: 'type|=|' + ProductTypes[2].value }
                    }
                },
                {
                    path: 'produits/:group/:id',
                    name: 'single-product',
                    redirect: { name: 'product-data-sheet' },
                    components: {
                        app_content: require('../views/products/single/Single.vue').default
                    },

                    children: [
                        {
                            path: 'fiche-technique',
                            name: 'product-data-sheet',
                            components: {
                                default: require('../views/products/single/DataSheet.vue').default
                            }
                        },
                        {
                            path: 'accessoires',
                            name: 'product-accessories',
                            components: {
                                default: require('../views/products/single/Accessories.vue').default
                            }
                        },
                        {
                            path: 'pieces-detaches',
                            name: 'product-components',
                            components: {
                                default: require('../views/products/single/Components.vue').default
                            }
                        },
                        {
                            path: 'consomables',
                            name: 'product-consumables',
                            components: {
                                default: require('../views/products/single/Consumables.vue').default
                            }
                        },
                        {
                            path: 'fichiers',
                            name: 'product-files',
                            components: {
                                default: require('../views/products/single/Files.vue').default
                            }
                        },
                        {
                            path: 'commentaires',
                            name: 'product-comments',
                            components: {
                                default: require('../views/products/single/Comments.vue').default
                            }
                        },
                        {
                            path: 'demandes',
                            name: 'product-requests',
                            components: {
                                default: require('../views/products/single/Requests.vue').default
                            }
                        },
                        {
                            path: 'controles',
                            name: 'product-tests',
                            components: {
                                default: require('../views/products/single/Tests.vue').default
                            }
                        }
                    ]
                },
                //#endregion


                //#region - Symbols
                {
                    path: 'symboles',
                    name: 'list-symbols',
                    components: {
                        app_content: require('../views/symbols/list/List.vue').default
                    }
                }
                //#endregion

            ]
        },

        {
            path: '/auth',
            component: require('../layouts/auth/Layout.vue').default,

            //#region - auth
            children: [
                {
                    path: 'login',
                    component: require('../views/auth/Login.vue').default
                }
            ]
            //#endregion
        },

        {
            path: '/admin',
            name: 'admin',
            redirect: { name: 'admin-users' },
            component: require('../layouts/admin/Layout.vue').default,

            children: [

                //#region - users
                {
                    path: 'utilisateurs',
                    name: 'admin-users',
                    components: {
                        app_content: require('../views/admin/users/list/List.vue').default
                    }
                },
                {
                    path: 'utilisateurs/:id',
                    name: 'admin-single-user',
                    redirect: { name: 'admin-single-user-general'},
                    components: {
                        app_content: require('../views/admin/users/single/Single.vue').default
                    },

                    children: [
                        {
                            path: 'general',
                            name: 'admin-single-user-general',
                            components: {
                                default: require('../views/admin/users/single/General.vue').default
                            }
                        }
                    ]
                },
                //#endregion

                //#region - sync
                {
                    path: 'synchro',
                    name: 'admin-sync',
                    components: {
                        app_content: require('../views/admin/sync/single.vue').default
                    }
                },
                //#endregion

            ]
        }
    ],
})

router.beforeResolve(Auth.isConnected)



// WEBPACK FOOTER //
// ./src/router/index.js